export const displayCategory = [
	{
		id: "1",
		title: "Hand Tufted Rugs",
		path: "/categories/hand-tufted-rugs",
		img: "/images/productList/cat_1.jpg",
		text: "Experience the beauty of handmade Rugs",
	},
	{
		id: "2",
		title: "Hand Knotted Rugs",
		path: "/categories/hand-knotted-rugs",
		img: "/images/productList/cat_2.jpg",
	},
	{
		id: "3",
		title: "Flatweave / Kilim Rugs",
		path: "/categories/flatweave-kilim-rugs",
		img: "/images/productList/cat_3.jpg",
	},
	{
		id: "4",
		title: "Hand Woven Rugs",
		path: "/categories/hand-woven-rugs",
		img: "/images/productList/cat_4.jpeg",
		text: "House of Rugs x The Design House Company",
	},
	{
		id: "5",
		title: "Custom Loom Rugs",
		path: "/categories/custom-loom-rugs",
		img: "/images/productList/cat_5.jpg",
		text: "House of Rugs x Gur Organics",
	},
	{
		id: "6",
		title: "Machine Made Rugs",
		path: "/categories/machine-made-rugs",
		img: "/images/productList/cat_6.jpg",
		text: "House of Rugs for Bharat Flooring x Ecru designs",
	},
];
